module.exports = __webpack_public_path__ + "img/image_zhanwei3.b200ae04.png";